import * as React from 'react'
import * as SwitchPrimitive from '@radix-ui/react-switch'

import { cn } from './utils'

type SwitchSize = 'sm' | 'md' | 'lg'

const sizeClasses = {
  sm: {
    root: 'h-[1.15rem] w-8',
    thumb: 'size-4',
  },
  md: {
    root: 'h-[1.5rem] w-10',
    thumb: 'size-5',
  },
  lg: {
    root: 'h-[2rem] w-16',
    thumb: 'size-8',
  },
}

interface SwitchProps extends React.ComponentProps<typeof SwitchPrimitive.Root> {
  size?: SwitchSize
}

function Switch({ className, size = 'md', ...props }: SwitchProps) {
  const rootSize = sizeClasses[size]?.root ?? sizeClasses.md.root
  const thumbSize = sizeClasses[size]?.thumb ?? sizeClasses.md.thumb

  // Calculate thumb translation for checked state based on size
  const thumbTranslate =
    size === 'sm'
      ? 'data-[state=checked]:translate-x-[calc(100%-2px)]'
      : size === 'md'
        ? 'data-[state=checked]:translate-x-[calc(100%-2px)]'
        : 'data-[state=checked]:translate-x-[calc(100%-2px)]'

  return (
    <SwitchPrimitive.Root
      data-slot="switch"
      className={cn(
        `peer data-[state=checked]:bg-primary data-[state=unchecked]:bg-slate-200 focus-visible:border-ring focus-visible:ring-ring/50 dark:data-[state=unchecked]:bg-input/80 inline-flex shrink-0 items-center rounded-full border border-transparent shadow-xs transition-all outline-none focus-visible:ring-[3px] disabled:cursor-not-allowed disabled:opacity-50 ${rootSize}`,
        className,
      )}
      {...props}>
      <SwitchPrimitive.Thumb
        data-slot="switch-thumb"
        className={cn(
          `bg-background data-[state=unchecked]:bg-primary data-[state=checked]:bg-white pointer-events-none block rounded-full ring-0 transition-transform data-[state=unchecked]:translate-x-0 ${thumbSize} ${thumbTranslate}`,
        )}
      />
    </SwitchPrimitive.Root>
  )
}

export { Switch }
